import React from 'react';

// import { ReactComponent as ArrowDownIcon } from 'pages/Teachers/StudentDetail/assets/arrow-down.svg';
import { ReactComponent as StandardIcon } from 'pages/Teachers/StudentDetail/assets/standard.svg';

import styles from './styles.module.scss';

const GoalRow = ({
  title,
  description,
  standards = [],
  date,
  progress,
  targetAccuracy
}) => {
  const getStatusColor = ({ progress, targetAccuracy }) => {
    if (progress < targetAccuracy / 2) return 'pink';

    if (progress < targetAccuracy) return 'yellow';

    return 'green';
  };

  const statusColor = getStatusColor({
    progress,
    targetAccuracy
  });

  const getProgressColorClass = ({ color }) => {
    switch (color) {
      case 'green':
        return styles.fillGreen;
      case 'yellow':
        return styles.fillYellow;
      case 'pink':
        return styles.fillPink;
      default:
        return styles.fillGreen;
    }
  };

  return (
    <div className={styles.goalRow}>
      <div className={styles.colGoal}>
        {title && <div className={styles.goalTitle}>{title}</div>}
        <div className={styles.goalDescription}>{description}</div>

        <div className={styles.tagsContainer}>
          {standards.map((standard, index) => (
            <span key={index} className={styles.tag}>
              <StandardIcon />
              {standard.code}
            </span>
          ))}
        </div>
      </div>

      <div className={styles.colDate}>
        <span className={styles.dateText}>{date}</span>
      </div>

      <div className={styles.colProgress}>
        <div className={styles.progressContainer}>
          <div className={styles.progressBarWrapper}>
            <div
              className={`${styles.progressFill} ${getProgressColorClass({
                color: statusColor
              })}`}
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className={styles.progressLabel}>{progress}%</span>
          {/* <ArrowDownIcon /> */}
        </div>
      </div>
    </div>
  );
};

export default GoalRow;
